import React, { useState, createContext, useContext } from 'react';
type CommitteeContextType = {
  selectedIndex: number;
  setSelectedIndex: (idx: number) => void;
  selectedCommittee: string;
  setSelectedCommittee: (committee: string) => void;
};
const CommitteeContext = createContext<CommitteeContextType>({
  selectedIndex: 0,
  setSelectedIndex: () => {},
  selectedCommittee: '',
  setSelectedCommittee: () => {}
});
export function CommitteeProvider({
  children
}: {
  children: React.ReactNode;
}) {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedCommittee, setSelectedCommittee] = useState('');
  return <CommitteeContext.Provider value={{
    selectedIndex,
    setSelectedIndex,
    selectedCommittee,
    setSelectedCommittee
  }} data-id="element-124">
      {children}
    </CommitteeContext.Provider>;
}
export function useCommitteeContext() {
  return useContext(CommitteeContext);
}